import EqualHeightComponent from '@bbkPricingPage/components/equal-height-component/equal-height-component';

export const DiscountLabel = ({
  label,
  show,
  ignoreEqualHeight = false,
}: {
  label?: string;
  show?: boolean;
  ignoreEqualHeight?: boolean;
}) => {
  return (
    <EqualHeightComponent
      groupId="dynamic-height-pricing-card-discount-label"
      ignore={ignoreEqualHeight}
    >
      <div>
        {show && label && (
          <div className="tw-w-fit tw-rounded-pricingtable-border-radius tw-bg-pricingtable-accent tw-px-2 tw-py-0.5 tw-text-center tw-text-sm tw-font-medium tw-text-pricingtable-text-contrast">
            {label}
          </div>
        )}
      </div>
    </EqualHeightComponent>
  );
};
